let ocs_accordion = jQuery('.accordion__title a')

ocs_accordion.on('click', function (e) {

    e.preventDefault()

    let thisEl = jQuery(this),
        thisParent = thisEl.parent()

    thisParent.toggleClass('open').next().slideToggle()

})

jQuery('.tab__sections li:first-child a').addClass('selected')
jQuery('.tab__sections li:first-child').addClass('selected')

jQuery('.tab__sections a').on('click', function(e) {

    e.preventDefault()

    let parentLi = jQuery(this).parent()
    let parentLiIndex = parentLi.index()
    let wrapper = jQuery(this).parents('.tab')

    wrapper.find('.tab__sections a').removeClass('selected')
    wrapper.find('.tab__sections li').removeClass('selected')
    jQuery(this).addClass('selected')
    jQuery(this).parent().addClass('selected')

    wrapper.find('.tab__content').hide().eq(parentLiIndex).show()

    console.log(parentLiIndex)

})

//I GUESS THIS SHOULD BE IN THE PLUGIN - @TODO
let accordion = jQuery('.mortar-accordion__title a')

accordion.on('click', function (e) {

    e.preventDefault()

    let thisEl = jQuery(this),
        thisParent = thisEl.parent()

    thisParent.toggleClass('open')

})

jQuery('.mortar-tabs__list li:first-child a').addClass('selected')
jQuery('.mortar-tabs__list li:first-child').addClass('selected')

jQuery('.mortar-tabs__list a').on('click', function(e) {

    e.preventDefault()

    let parentLi = jQuery(this).parent()
    let parentLiIndex = parentLi.index()
    let wrapper = jQuery(this).parents('.mortar-tabs')

    wrapper.find('.mortar-tabs__list a').removeClass('selected')
    wrapper.find('.mortar-tabs__list li').removeClass('selected')
    jQuery(this).addClass('selected')
    jQuery(this).parent().addClass('selected')

    wrapper.find('.mortar-tabs__content').hide().eq(parentLiIndex).show()

})
